import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import React from 'react'
import { LoginButtonEntityInterface } from 'src/shared/entities/login-button/login-button-entity.schema'
import { BaseEditorButton } from '../base-editor-button'

export interface LoginButtonProps {
  entity: LoginButtonEntityInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

export const LoginButton = ({
  entity,
  isMoveUpAllowed,
  isMoveDownAllowed,
}: LoginButtonProps) => {
  return (
    <BaseEntityNew
      entity={entity}
      flex
      flexColumn
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <BaseEditorButton entityOrSubEntity={entity}></BaseEditorButton>
    </BaseEntityNew>
  )
}
